"use client";

import React, { useState } from "react";
import Icon from "@/components/ui/AppIcon";

interface SaveContactButtonProps {
  name: string;
  title: string;
  company: string;
  email: string;
  phone: string;
  website: string;
}

export default function SaveContactButton({
  name,
  title,
  company,
  email,
  phone,
  website,
}: SaveContactButtonProps) {
  const [saved, setSaved] = useState(false);

  const handleSave = () => {
    const nameParts = name.split(" ");
    const firstName = nameParts[0] || "";
    const lastName = nameParts.slice(1).join(" ") || "";

    const lines = [
      "BEGIN:VCARD",
      "VERSION:3.0",
      "N:" + lastName + ";" + firstName + ";;;",
      "FN:" + name,
      "TITLE:" + title,
      "ORG:" + company,
      "EMAIL;TYPE=INTERNET,PREF:" + email,
      "TEL;TYPE=WORK,VOICE:" + phone,
      "URL:" + website,
      "END:VCARD",
    ];
    const vcard = lines.join("\r\n");
    const filename = name.replace(/\s+/g, "_") + ".vcf";

    // data URI approach — works on iOS Safari and Android Chrome
    const dataUri = "data:text/vcard;charset=utf-8," + encodeURIComponent(vcard);
    const a = document.createElement("a");
    a.href = dataUri;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    setSaved(true);
    setTimeout(() => setSaved(false), 3000);
  };

  return (
    <div className="px-4 pt-4 pb-6 fade-in-up delay-800 sm:px-6 sm:pt-6 sm:pb-8">
      <button
        onClick={handleSave}
        className="save-btn w-full bg-primary text-white font-jakarta font-bold rounded-full flex items-center justify-center gap-3 ripple-container"
        style={{ height: "60px", fontSize: "17px" }}
        aria-label="Save contact to phone"
      >
        {saved ? (
          <>
            <Icon name="CheckCircleIcon" size={24} variant="solid" className="text-white flex-shrink-0" />
            <span>Contact Saved!</span>
          </>
        ) : (
          <>
            <Icon name="UserPlusIcon" size={24} variant="outline" className="text-white flex-shrink-0" />
            <span>Save Contact</span>
          </>
        )}
      </button>
    </div>
  );
}